import React from 'react';
import { X } from 'lucide-react';

// Side-by-side raw vs mapped sample. Read-only; user closes when done.

const TestSampleModal = ({ open, onClose, loading, result, error }) => {
  if (!open) return null;
  return (
    <div className="tw-fixed tw-inset-0 tw-z-50 tw-bg-black/40 tw-flex tw-items-center tw-justify-center tw-p-4">
      <div className="tw-bg-white tw-rounded-xl tw-shadow-xl tw-w-full tw-max-w-5xl tw-max-h-[85vh] tw-flex tw-flex-col">
        <div className="tw-flex tw-items-center tw-justify-between tw-px-5 tw-py-4 tw-border-b tw-border-gray-200">
          <h3 className="tw-text-base tw-font-semibold tw-text-gray-900 tw-m-0">
            Test sample — first IMPORT group
          </h3>
          <button
            type="button"
            onClick={onClose}
            className="tw-p-1 tw-text-gray-500 hover:tw-text-gray-900 tw-bg-transparent tw-border-0 tw-cursor-pointer"
          >
            <X className="tw-w-5 tw-h-5" />
          </button>
        </div>

        {loading && <div className="tw-p-6 tw-text-sm tw-text-gray-500">Running…</div>}
        {error && (
          <div className="tw-p-6 tw-text-sm tw-text-red-600">
            <strong>Error:</strong> {error}
          </div>
        )}
        {result && (
          <div className="tw-p-5 tw-grid tw-grid-cols-2 tw-gap-4 tw-overflow-auto">
            <div>
              <p className="tw-text-xs tw-uppercase tw-tracking-wider tw-text-gray-400 tw-font-semibold tw-mb-2">
                Source record (first of {result.recordCount})
              </p>
              <pre className="tw-text-xs tw-bg-gray-50 tw-p-3 tw-rounded-lg tw-overflow-auto tw-whitespace-pre-wrap tw-max-h-[60vh]">
                {JSON.stringify(result.sampleRecord, null, 2)}
              </pre>
            </div>
            <div>
              <p className="tw-text-xs tw-uppercase tw-tracking-wider tw-text-gray-400 tw-font-semibold tw-mb-2">
                Mapped employee payload
              </p>
              <pre className="tw-text-xs tw-bg-gray-50 tw-p-3 tw-rounded-lg tw-overflow-auto tw-whitespace-pre-wrap tw-max-h-[60vh]">
                {JSON.stringify(result.mapped, null, 2)}
              </pre>
              {result.errors?.length > 0 && (
                <div className="tw-mt-3 tw-p-3 tw-bg-red-50 tw-rounded-lg tw-text-xs tw-text-red-700">
                  <p className="tw-font-semibold tw-mb-1">Mapping errors:</p>
                  <ul className="tw-list-disc tw-pl-4 tw-m-0">
                    {result.errors.map((e, i) => (
                      <li key={i}>{e}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TestSampleModal;
